import React, { useEffect, useState } from 'react';
import styles from './DeviceHeader.module.scss';
import PinIcon from '../../../../assets/svg/place_24px.svg';
import { ReactComponent as EditIcon } from '../../../../assets/svg/edit.svg';
import ModalImage from '../../../ModalImage';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { iFullStoreState } from '../../../../shared/interfaces';
import { DashboardSize } from '../../../../stores/reducers/dashboardInfo';
import { Tooltip } from '@mui/material';

const FormatDeviceAddress = ({ address }) => {
  if (!address) {
    return <div className={styles.DeviceFormattedAddress}>No Tracking Available</div>;
  }

  const {
    street = '',
    city = '',
    state = '',
    zip = '',
  } = address;

  const clean = (text) =>
    text
      .replace(/\S*\+\S*/g, '')
      .replace(/\bUS\b/gi, '')
      .replace(/\s+/g, ' ')
      .trim();

  const cleanStreet = clean(street);
  const cleanCity = clean(city);
  const cleanState = clean(state);
  const cleanZip = clean(zip);

  const formattedLine1 = cleanStreet;
  const formattedLine2 = [cleanCity, cleanState, cleanZip].filter(Boolean).join(', ');

  return (
    <div className={styles.DeviceFormattedAddress}>
      {formattedLine1 && <span style={{ color: '#333' }}>{formattedLine1}</span>}
      {formattedLine2 && <span style={{ color: '#333' }}>{formattedLine2}</span>}
    </div>
  );
}

const DeviceHeader = ({ name, address, clickHandler, iconUrl, editDeviceInfo: {editDeviceHandler, isShowEditButton, onNameUpdate} }) => {
  const [isFullImage, setIsFullImage] = useState<boolean>(false);
  const [isEditingName, setIsEditingName] = useState<boolean>(false);
  const [editedName, setEditedName] = useState<string>(name);
  const size = useSelector<iFullStoreState, DashboardSize>((s) => s.dashboardInfo.size);

  useEffect(() => {
    setEditedName(name);
  }, [name]);

  const isNotFullDashboard = size !== DashboardSize.OPEN_FULL;

  const handleSaveName = async () => {
    if (editedName.trim() !== name) {
      await onNameUpdate(editedName.trim());
    }
    setIsEditingName(false);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      (e.target as HTMLInputElement).blur();
    }
    if (e.key === 'Escape') {
      setEditedName(name);
      setIsEditingName(false);
    }
  };

  return (
    <div className={styles.DeviceHeader}>
      <div className={styles.DeviceHeaderImage}>
        <img src={iconUrl !== '' ? iconUrl : 'images/no_car_image.jpg'} onClick={() => setIsFullImage(true)} />
      </div>
      <div className={classNames(styles.DeviceHeaderInfo, { [styles.smallDashboard]: isNotFullDashboard })}>
        <div className={styles.DeviceHeaderInfoLocation}>
          <FormatDeviceAddress address={address} />
        </div>
        <div className={styles.DeviceHeaderNameSection}>
          <div className={styles.DeviceHeaderName}>
            <input
              type="text"
              value={editedName}
              onChange={(e) => setEditedName(e.target.value)}
              onBlur={handleSaveName}
              onKeyDown={handleKeyDown}
              className={styles.editableInput}
            />
          </div>
        </div>
      </div>
      {isShowEditButton && (<Tooltip title='Edit device' placement='top'>
        <button className={styles.editDeviceIcon} onClick={editDeviceHandler}>
          <EditIcon />
        </button>
      </Tooltip>)}
      {isFullImage && (
        <ModalImage
          closeImageHandler={() => setIsFullImage(false)}
          imageSrc={iconUrl !== '' ? iconUrl : 'images/no_car_image.jpg'}
          isNoImage={iconUrl === ''}
        />
      )}
    </div>
  )
}

export default DeviceHeader;